import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import FormControlLabel from "@mui/material/FormControlLabel";
import IconButton from "@mui/material/IconButton";
import MapIcon from "@mui/icons-material/Map";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import StyledTooltip from "../UI/StyledTooltip";

import { mapActions } from "../../store";

import { basemapPosition } from "../../config/config.layout";
import { iconButtonStyle, styles } from "../../config/config.theme";
import { basemapStyles } from "../../config/config.basemap";

const Basemap = () => {
  const dispatch = useDispatch();
  const basemapSelection = useSelector((state) => state.map.basemap);
  const [isOpen, setIsOpen] = useState(false);
  const handleChange = (e) => {
    dispatch(mapActions.setBasemap(basemapStyles[e.target.value]));
  };

  return (
    <>
      <StyledTooltip
        title="Select a basemap"
        placement={
          basemapPosition.tooltipPlacement
            ? basemapPosition.tooltipPlacement
            : "right"
        }
        disableFocusListener
        enterTouchDelay={0}
      >
        <IconButton
          aria-label="basemap selection"
          variant="outlined"
          onClick={() => {
            setIsOpen((prevState) => !prevState);
          }}
          sx={{
            ...iconButtonStyle,
            "&:hover": { backgroundColor: styles["background-primary"] },
            "&:active": { backgroundColor: styles["background-primary"] },
            "&:focus": { backgroundColor: styles["background-primary"] },
          }}
        >
          <MapIcon fontSize="1.5rem" color="primary" />
        </IconButton>
      </StyledTooltip>

      <Dialog open={isOpen} onClose={() => setIsOpen(false)}>
        <DialogTitle>Select Basemap</DialogTitle>
        <DialogContent sx={{ minWidth: "300px" }}>

          <RadioGroup
            aria-labelledby="basemap-radio-buttons-group"
            name="radio-buttons-group"
            value={Object.keys(basemapStyles).find(
              (name) => basemapStyles[name].src === basemapSelection.src
            )}
            onChange={handleChange}
          >
            {Object.keys(basemapStyles).map((key) => (
              <FormControlLabel
                key={key}
                control={<Radio color="accent" />}
                label={basemapStyles[key].label}
                value={key}
              />
            ))}
          </RadioGroup>
        </DialogContent>
        <DialogActions>
          <Button
            aria-label="close overlay selection"
            autoFocus
            onClick={() => setIsOpen(false)}
            color="secondary"
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default Basemap;
